// Central data source for the whole personal brand site.
// Keeping all copy + links here so future edits are one-file edits.

export const PROFILE = {
    name: "Mohammad Naved",
    tagline: "Building digital experiences, scalable businesses, and growth-focused solutions that create measurable impact.",
    roles: ["Web Developer", "Digital Strategist", "Growth Consultant", "Entrepreneur"],
    email: "mohammadnaved925@gmail.com",
    github: "https://github.com/Mn2902",
    location: "Available worldwide · Remote",
    signature: "Building Digital Experiences."
};

export const NAV_LINKS = [
    { id: "about", label: "About" },
    { id: "ventures", label: "Ventures" },
    { id: "projects", label: "Work" },
    { id: "services", label: "Services" },
    { id: "stack", label: "Stack" },
    { id: "approach", label: "Approach" },
    { id: "insights", label: "Insights" },
    { id: "contact", label: "Contact" }
];

export const VENTURES = [
    {
        id: "elite-edge",
        name: "Elite-Edge US",
        role: "Founder",
        tag: "Digital Agency",
        pitch:
            "A premium digital agency delivering websites, eCommerce experiences, SEO systems, and end-to-end digital growth for brands across the US, Canada & beyond.",
        highlights: ["Websites", "eCommerce", "SEO", "Digital Growth"],
        url: "https://elite-edge.us"
    },
    {
        id: "boostf",
        name: "BoostF",
        role: "Founder",
        tag: "Entrepreneur Platform",
        pitch:
            "A platform supporting entrepreneurs in launching, marketing, and scaling their eCommerce businesses with practical, real-world strategies.",
        highlights: ["Shopify", "Playbooks", "Community", "Mentorship"],
        url: "https://boostf.org"
    },
    {
        id: "consulting",
        name: "Independent Consulting",
        role: "Consultant",
        tag: "Strategy & Systems",
        pitch:
            "Working directly with startups and established businesses to design scalable digital solutions — from architecture to growth engineering.",
        highlights: ["Strategy", "Architecture", "Growth", "Systems"],
        url: null
    }
];

export const PROJECTS = [
    {
        id: "elite-edge",
        title: "Elite-Edge US",
        category: "Digital Agency · Founder",
        description:
            "The flagship agency site. High-performance, conversion-oriented layout designed to communicate authority and drive qualified leads for premium digital services.",
        tech: ["React", "Tailwind CSS", "Framer Motion", "SEO", "Meta Ads"],
        image: "/projects/elite-edge.jpg",
        url: "https://elite-edge.us"
    },
    {
        id: "the-elica",
        title: "The Elica",
        category: "Fashion eCommerce",
        description:
            "A minimalist luxury fashion storefront with an editorial hero, curated collections, and a friction-less checkout tuned for repeat customers.",
        tech: ["Shopify", "Liquid", "UI/UX", "Conversion Optimization"],
        image: "/projects/the-elica.jpg",
        url: "https://the-elica.us"
    },
    {
        id: "redsheepleather",
        title: "Red Sheep Leather",
        category: "Leather Goods · eCommerce",
        description:
            "A rich, cinematic online store for a handcrafted leather brand — atmospheric hero, product storytelling, and an immersive purchase journey.",
        tech: ["WooCommerce", "WordPress", "SEO", "Performance"],
        image: "/projects/redsheepleather.jpg",
        url: "https://redsheepleather.com"
    },
    {
        id: "rignrizz",
        title: "Rig N Rizz",
        category: "Fashion · Shopify",
        description:
            "Editorial-driven Shopify build for a modern lifestyle brand. Focused on collection browsing, product depth, and a mobile-first shopping flow.",
        tech: ["Shopify", "UI/UX", "Meta Ads", "Google Ads"],
        image: "/projects/rignrizz.jpg",
        url: "https://rignrizz.com"
    },
    {
        id: "boostf",
        title: "BoostF",
        category: "Education · Platform",
        description:
            "A learning + community platform helping entrepreneurs launch Shopify stores. Clear value-prop hero, funnel-first structure, and lead-generation baked in.",
        tech: ["Next.js", "Marketing", "Landing Page", "Funnel"],
        image: "/projects/boostf.jpg",
        url: "https://boostf.org"
    }
];

export const SERVICES = [
    { title: "Modern Websites", icon: "Globe", desc: "Design + build for brands that must look inevitable." },
    { title: "React Applications", icon: "Component", desc: "Fast, typed, modular front-ends built to scale." },
    { title: "WordPress Websites", icon: "PenTool", desc: "Content-first sites tuned for SEO and speed." },
    { title: "WooCommerce Stores", icon: "ShoppingBag", desc: "Full commerce systems from catalogue to checkout." },
    { title: "Shopify Stores", icon: "Store", desc: "Storefronts engineered for conversion & retention." },
    { title: "Landing Pages", icon: "LayoutTemplate", desc: "High-velocity pages tuned for a single outcome." },
    { title: "UI / UX Design", icon: "Sparkles", desc: "Clarity, hierarchy, and the small details that convert." },
    { title: "SEO Optimization", icon: "Search", desc: "Technical + on-page systems that compound over months." },
    { title: "Performance Marketing", icon: "TrendingUp", desc: "Media buying that ties every dollar to revenue." },
    { title: "Meta Ads", icon: "Facebook", desc: "Creative + funnel + audience — engineered to scale." },
    { title: "Google Ads", icon: "MousePointerClick", desc: "Search & shopping ads built on real intent data." },
    { title: "Conversion Optimization", icon: "Target", desc: "Turn existing traffic into more paying customers." },
    { title: "Speed Optimization", icon: "Zap", desc: "Sub-second loads. Real Lighthouse gains." },
    { title: "AI Automation", icon: "Bot", desc: "Wire AI into ops, marketing, and support flows." },
    { title: "Growth Strategy", icon: "Compass", desc: "The plan behind the pixels — where the market is going." }
];

export const STACK_GROUPS = [
    {
        label: "Frontend",
        items: ["React", "JavaScript", "TypeScript", "Vite", "Tailwind CSS", "HTML5", "CSS3"]
    },
    {
        label: "CMS & Commerce",
        items: ["WordPress", "WooCommerce", "Shopify"]
    },
    {
        label: "Backend & Tooling",
        items: ["Node.js", "Git", "GitHub", "EmailJS"]
    },
    {
        label: "Design",
        items: ["Figma", "UI/UX", "Responsive Design"]
    },
    {
        label: "Growth",
        items: ["Google Analytics", "Google Ads", "Meta Ads", "Meta Pixel", "SEO", "Performance Optimization", "AI Automation"]
    }
];

export const APPROACH = [
    {
        n: "01",
        title: "Technology should solve problems.",
        body: "Not decorate them. Every choice — framework, library, integration — has to earn its place by moving a business number."
    },
    {
        n: "02",
        title: "Design builds trust.",
        body: "Before a single feature is used, the interface has already made a promise. My work honours that promise with clarity, restraint, and craft."
    },
    {
        n: "03",
        title: "Fast websites convert.",
        body: "Speed is a feature and a design decision. Sub-second loads, deliberate motion, and interactions that never make people wait."
    },
    {
        n: "04",
        title: "Marketing needs a strong asset.",
        body: "You can’t out-spend a weak website. The site, funnel, and offer have to be strong before paid media becomes profitable."
    },
    {
        n: "05",
        title: "Everything must contribute to growth.",
        body: "Design, code, copy, ads — all of it laddered to measurable outcomes. Revenue, retention, brand equity, or nothing."
    }
];

export const BLOG_CATEGORIES = [
    "All",
    "Web Development",
    "SEO",
    "Digital Marketing",
    "Performance Marketing",
    "Business Growth",
    "React",
    "WordPress",
    "WooCommerce",
    "AI",
    "Entrepreneurship"
];

// Placeholder posts — every card shows a "Coming soon" state (per requirements).
export const BLOG_POSTS = [
    { title: "Design Systems That Scale With The Business", category: "Web Development" },
    { title: "What Actually Moves SEO Rankings in 2026", category: "SEO" },
    { title: "The Landing-Page Anatomy That Converts", category: "Digital Marketing" },
    { title: "AI Automation for Small Teams", category: "AI" },
    { title: "From Zero to First Shopify Sale", category: "Entrepreneurship" },
    { title: "Reading The Numbers Behind Meta Ads", category: "Performance Marketing" }
];
